const $ = require('jquery');
const _ = require('lodash');

// Set event for the browser window like resize and orientation change
// debounce the event, get the params
// broadcast events and params
// important: need to call init() (happen only one time)
function BrowserWindowService($rootScope, breakpointsService) {
    this.window = {};
    this.window.height = 0;
    this.window.width = 0;
    this.isInit = false;
    this.$rootScope = $rootScope;
    this.breakpointsService = breakpointsService;

    this.availableFormat = {
        large: 'lg',
        medium: 'md',
        small: 'sm',
    };

    this.selectedFormat = this.availableFormat.Large;
}

BrowserWindowService.prototype.init = function () {
    if (!this.isInit) {
        $(window).resize(_.debounce(() => {
            const resizeChanges = this.getWindowSize();
            this.$rootScope.$broadcast('window:resize', this.window);

            if (resizeChanges.widthChanged) {
                this.$rootScope.$broadcast('window:widthResize', this.window);
                this.broadcastFormatChange();
            }
            if (resizeChanges.heightChanged) {
                this.$rootScope.$broadcast('window:heightResize', this.window);
            }

            this.$rootScope.$apply();
        }, 500));

        this.getWindowSize();
    }
    this.isInit = true;
};

// broadcast when the format change: if you want to watch more than one state, you can do a watch on BrowserWindowService.selectedFormat
BrowserWindowService.prototype.broadcastFormatChange = function () {
    if (this.breakpointsService.isSmallFormat() && this.selectedFormat !== this.availableFormat.small) {
        this.$rootScope.$broadcast('window:widthResize:small', self.window);
        this.selectedFormat = this.availableFormat.small;
    } else if (!this.breakpointsService.isSmallFormat()) {
        this.$rootScope.$broadcast('window:widthResize:mediumorlarge', self.window);
        if (this.breakpointsService.isMediumFormat() && this.selectedFormat !== this.availableFormat.medium) {
            this.$rootScope.$broadcast('window:widthResize:medium', self.window);
            this.selectedFormat = this.availableFormat.medium;
        } else if (this.breakpointsService.isLargeFormat() && this.selectedFormat !== this.availableFormat.large) {
            this.$rootScope.$broadcast('window:widthResize:large', self.window);
            this.selectedFormat = this.availableFormat.large;
        }
    }
};

BrowserWindowService.prototype.getWindowSize = function () {
    let heightChanged = false;
    let widthChanged = false;

    if (this.window.height !== $(window).height()) {
        this.window.height = $(window).height();
        heightChanged = true;
    }

    if (this.window.width !== $(window).width()) {
        this.window.width = $(window).width();
        widthChanged = true;
    }

    return { widthChanged, heightChanged };
};

module.exports = BrowserWindowService;



// WEBPACK FOOTER //
// ./src/common/breakpoints/browserwindow.service.js